import React from "react";
import "./skeleton.css";

const ProjectSkeleton = () => {
  return (
    <tr className="project-skeleton-row">
      <td className="p-3 align-middle">
        <div className="project-skeleton-title skeleton-shimmer" aria-hidden="true" />
      </td>
      <td className="p-3 align-middle">
        <div className="project-skeleton-badge skeleton-shimmer" aria-hidden="true" />
      </td>
      <td className="p-3 align-middle">
        <div className="project-skeleton-status skeleton-shimmer" aria-hidden="true" />
      </td>
      <td className="p-3 align-middle">
        <div className="project-skeleton-date skeleton-shimmer" aria-hidden="true" />
      </td>
      <td className="p-3 align-middle">
        <div className="project-skeleton-actions" aria-hidden="true">
          <div className="project-skeleton-open skeleton-shimmer" />
          <div className="project-skeleton-menu skeleton-shimmer" />
        </div>
      </td>
    </tr>
  );
};

export default ProjectSkeleton;
